export function addInventoryRow(button) {
    const row = button.closest('tr');

    row.classList.remove('no-inventory');
    setRemovedFlag(row, '0');
    row.querySelector('.stepped-integer input').focus();

    touchForm(button);
}

export function removeInventoryRow(button) {
    const row = button.closest('tr');

    row.querySelectorAll('input').forEach(input => {
        input.value = '';
    });
    setRemovedFlag(row, '1');
    row.classList.add('no-inventory');

    touchForm(button);
}

function setRemovedFlag(row, value) {
    row.querySelector('input[name$="_removed"]').value = value;
}

function touchForm(button) {
    button.form.dispatchEvent(new CustomEvent('form:touch'));
}
